import { MENTION_KEY } from '@techchange/pm-specs';

/**
 * Inserts a mention node at the beginning of the tracked mention range.
 *
 * @param {Object} attrs  The mention attributes.
 * @param {Number} start  The start position of the mention.
 * @param {Number} end    The end position of the mention.
 *
 * @returns {Function} Parametrized command to insert a mention.
 *
 */
export const insertMention = (attrs, start, end) => {

	return (state, dispatch) => {

		const { schema, tr } = state;

		const mentionNodeType = schema.nodes[MENTION_KEY];

		const newMentionNode = mentionNodeType.create(attrs);

		// Replace type-ahead text and @ character with trailing space
		tr.insertText(' ', start, end);
		tr.insert(start, newMentionNode);
		tr.setMeta('deactivateMention', true);

		if (dispatch) {

			dispatch(tr);

		}

		return true;

	};

};
